export default __webpack_public_path__ + "static/media/rockabilly_print_thermal_top_2_370x450_crop_center.progressive.png.cdacc641.jpg";